import { Outlet } from "react-router-dom";
import Helmet from "react-helmet";

import ProofOfCoverageLayout from "@layouts/ProofOfCoverageLayout";

import { BASE_RESIDENTS_PATH } from "@routing/Residents";
import { ADD_EVENT_ROUTES } from "@routing/Residents/ProofOfCoverage";

import { getPageTitle } from "@utils";

export function AddCoverageEvent() {
  return (
    <>
      <Helmet>
        <title>{getPageTitle("Add Coverage Event")}</title>
      </Helmet>
      <ProofOfCoverageLayout
        isAddingEvent
        onClosePath={`/${BASE_RESIDENTS_PATH}`}
        cannotGoBackPaths={[
          ADD_EVENT_ROUTES.EVENT_TYPE,
          ADD_EVENT_ROUTES.EVENT_ADDED,
        ]}>
        <Outlet />
      </ProofOfCoverageLayout>
    </>
  );
}
